export class TipoDispositivo {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
